module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/companies/company-logo-14-c85d284c727c6221cbacec741fd106ab.png";